import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login_info: null,
    level_name_mapper: {
      '0': 'Free',
      '10': 'Starter',
      '20': 'Business',
      '30': 'Enterprise',
      '99': 'Nineder'
    },
  },
  getters: {
    login_info: state => {
      return state.login_info
    },
    level_name_mapper: state => {
      return state.level_name_mapper
    }
  },
  mutations: {
    setLoginInfo: function(state, login_info){
        state.login_info = login_info
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
